"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validate = exports.getInitialValue = void 0;
var _react = _interopRequireDefault(require("react"));
var _server = _interopRequireDefault(require("react-dom/server"));
var _isEmail = _interopRequireDefault(require("validator/lib/isEmail"));
var _isInt = _interopRequireDefault(require("validator/lib/isInt"));
var _replaceVars = _interopRequireDefault(require("cccisd-survey-common/dist/helpers/replaceVars.js"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _isString2 = _interopRequireDefault(require("lodash/isString"));
var _cccisdSurveyCommon = require("cccisd-survey-common");
var _cccisdWysiwyg = require("cccisd-wysiwyg");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var getInitialValue = exports.getInitialValue = function getInitialValue() {
  var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaultValueVariables = arguments.length > 1 ? arguments[1] : undefined;
  if (defaultValueVariables && settings.defaultValueVariable) {
    var defaultValue = (0, _get2["default"])(defaultValueVariables, settings.defaultValueVariable);
    if (!defaultValue) {
      console.error("There is no variable \"".concat(settings.defaultValueVariable, "\""));
    } else if (!(0, _isString2["default"])(defaultValue)) {
      console.error("The value of \"".concat(settings.defaultValueVariable, "\" variable should be a string"));
    } else {
      return defaultValue;
    }
  } else if (settings.defaultValue) {
    return (0, _cccisdSurveyCommon.stripTags)(_server["default"].renderToStaticMarkup( /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
      content: settings.defaultValue
    })), {
      keepLineBreaks: true
    }).replace(/\[object Object\]/g, '').replace(/<br\s*\/?>/gi, '\n');
  }
  return undefined;
};
var validate = exports.validate = function validate(value, settings) {
  var error;
  if (!value && settings.isRequired) {
    return settings.requiredErrorMessage;
  }
  if (value) {
    if (settings.validationRule === 'email' && !(0, _isEmail["default"])(value)) {
      return settings.emailErrorMessage;
    }
    if (settings.validationRule === 'number') {
      var stringValue = value.toString();
      if (!(0, _isInt["default"])(stringValue)) {
        return settings.numberErrorMessage;
      }
      if (settings.minNumber && !(0, _isInt["default"])(stringValue, {
        min: +settings.minNumber
      })) {
        return (0, _replaceVars["default"])(settings.minNumberErrorMessage, {
          min: settings.minNumber
        });
      }
      if (settings.maxNumber && !(0, _isInt["default"])(stringValue, {
        max: +settings.maxNumber
      })) {
        return (0, _replaceVars["default"])(settings.maxNumberErrorMessage, {
          max: settings.maxNumber
        });
      }
    }
    if (settings.validationRule === 'length') {
      if (settings.minCharacters && value.length < +settings.minCharacters) {
        return (0, _replaceVars["default"])(settings.minCharactersErrorMessage, {
          min: settings.minCharacters
        });
      }
      if (settings.maxCharacters && value.length > +settings.maxCharacters) {
        return (0, _replaceVars["default"])(settings.maxCharactersErrorMessage, {
          max: settings.maxCharacters
        });
      }
    }
    if (settings.validationRule === 'regex') {
      var regex;
      // eslint-disable-next-line no-eval
      eval("regex = ".concat(settings.regex, ";"));
      if (!regex.test(value)) {
        return settings.regexErrorMessage;
      }
    }
  }
  return error;
};